import React, {Component, Fragment, useEffect, useRef, useState} from 'react'
import {applyLang, getCurrencyData} from "../../../i18n";
import {ASSET_URL} from "../../../config";
import {getPurOrg} from "../../../utils";
import {startPaiement} from "../../../services/paiementLauncher";
import {useRouter} from "next/router";


export default function Products({context,campagneData,campagneTarget,forceSubmit})
{

    const org=context.org
    const isMobile=context.isMobile
    const formater=new Intl.NumberFormat('fr-FR', { maximumFractionDigits:0 })

    const router=useRouter()
    const currencyData=getCurrencyData(context.lang)

    const convertAmount=(amount)=>{
        return Math.round(amount/currencyData.rate)
    }

    let products=campagneData.products || []

    products=products.sort((a,b)=>{
        if(a.position === b.position){
            return 0
        }
        return a.position>b.position?1:-1
    })

    if(products.length === 0){
        return null
    }


    const onSubmit=(p)=>
    {

        const campagne={
            ...campagneTarget,
            theme:campagneData?.config?.secondaryColor,
            label:campagneData.label || "",
            assoc:campagneData?.assoc || "MAIN",
            id:campagneData?.id,
        }

        var object={
            montant: p.montant,
            divide:p.divide || 0,
            maxDivide:campagneData?.config?.maxDivideNB,
            monthlyAmountDisplay:!campagneData?.config?.productMonth && !!campagneData?.config?.monthlyAmountDisplay,
            returnUrl: window.location.href,
            organisation:getPurOrg(org),
            type: "CAMPAGNE",
            typeId: campagneData.id,
            cerfa: true,
            campagne:campagne
        }

        if(currencyData.id!=="EUR"){
            object.montant=Math.round(object.montant*currencyData.rate)
        }

        // Centralisé : source (APP/WEB) + returnUrl (deep link en app) + sessionStorage
        // + redirect. Cf. services/paiementLauncher.
        startPaiement(object, {org, router, query: "theme=CAMPAGNE"})
    }


    if(isMobile)
    {
        return (
            <div className={"products-section"} style={{width: "100%"}}>
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "stretch",
                    alignItems: "center",
                    width: "100%",
                    gap: 15
                }}>

                    {products.map(p => {
                        p = applyLang(p, context.lang)
                        return (
                            <div
                                className={"products-item"}
                                onClick={() => forceSubmit?onSubmit(p):context?.actions?.showModalDon(p.montant===0?[]:[p.id])}
                                style={{
                                    cursor: "pointer",
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    borderRadius: 20,
                                    textAlign: "center",

                                }}
                            >
                                {p.image && (
                                    <div>
                                        <img src={ASSET_URL + p.image} style={{
                                            borderRadius: "100%",
                                            width: 50,
                                            height: 50,
                                            objectFit: "cover"
                                        }}/>
                                    </div>
                                )}

                                {p.description &&(
                                    <>
                                       <div style={{
                                           color: "#FFF",
                                           fontSize: 14,
                                           textAlign: "center",
                                           width:"60%",
                                       }}>{p.description}</div>

                                        <span style={{color: "#FFF",fontSize:14, fontWeight: "600", textAlign: "center"}}>{p.name}</span>
                                    </>
                                )}

                                {!p.description &&(
                                    <>
                                        <span style={{color: "#FFF", fontWeight: "600", textAlign: "center"}}>{p.name}</span>
                                    </>
                                )}

                            </div>
                        )
                    })}

                </div>
            </div>
        )
    }

    return (
        <div className={"products-section"} style={{width: "100%",display:"flex",justifyContent:"center",alignItems:"center"}}>
            <div style={{
                display: "flex",
                flexDirection: "row",
                flexWrap:"wrap",
                justifyContent: "center",
                alignItems: "stretch",
                width: "100%",
                gap: 10,
                padding:"0 2%"
            }}>

                {products.map(p => {
                    p = applyLang(p, context.lang)
                    return (
                        <div
                            className={"products-item"}
                            onClick={() => forceSubmit?onSubmit(p):context?.actions?.showModalDon([p.id])}
                            style={{
                                cursor: "pointer",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                borderRadius: 5,
                                textAlign: "center",
                            }}
                        >
                            {p.image && (
                                <div>
                                    <img src={ASSET_URL + p.image} style={{
                                        borderRadius: "100%",
                                        width: 50,
                                        height: 50,
                                        objectFit: "cover"
                                    }}/>
                                </div>
                            )}

                            <div style={{width: "90%"}}>
                                <span style={{color: "#FFF",fontSize:16, fontWeight: "600", textAlign: "center"}}>{p.name}</span>
                            </div>

                            <div style={{width: "65%"}}>
                                <span style={{color: "#FFF", fontSize: 14, textAlign: "center",lineHeight:0.3}}>{p.description}</span>
                            </div>

                        </div>
                    )
                })}

            </div>
        </div>
    )
}
